import BurgerIconSvg from "assets/landing/icons/BurgerIconSvg";
import React from "react";
type BurgerIconProps = {
  handleClick?: () => void;
  isDark?: boolean;
};
const BurgerIcon: React.FC<BurgerIconProps> = ({ handleClick, isDark }) => {
  return (
    <button
      onClick={handleClick}
      className={`size-11 flex lg:hidden items-center justify-center burger-icon rounded-xl ${isDark ? "bg-white/10" : "bg-[#E9EBF3] custom-shadow"}`}
    >
      <span className={`size-7 flex items-center justify-center rounded-[4px] ${isDark ? "bg-white/20" : "bg-white"}`}>
        <BurgerIconSvg />
      </span>
    </button>
  );
};

export default BurgerIcon;
